// extracted by mini-css-extract-plugin
module.exports = {"ghost":"ShelfGhost_ghost__GlbDa"};